import axios from "axios";
import { toast } from "react-toastify";
import { API_V2_MEDIA_TYPE, toApiResponse } from "../dto/apiResponse";

const instance = axios.create({
    baseURL: process.env.REACT_APP_MAIN_API_URL || "",
    withCredentials: true,
    headers: { Accept: API_V2_MEDIA_TYPE },
});

instance.interceptors.response.use(
    response => toApiResponse(response.data, response.status),
    error => {
        if (!error.response) return Promise.reject(error);
        const status = error.response.status || 500;
        const payload = toApiResponse(error.response.data, status);
        if (status === 401 && !["/", "/login", "/user/forgotPassword"].includes(window.location.pathname)) {
            toast.error("Vui lòng đăng nhập trước.");
        }
        if (status === 403) toast.error("Bạn không có quyền truy cập");
        return payload;
    }
);

export default instance;
